import React from 'react';
import EmployeeAddContainer from '../../containers/employeemng/EmployeeAddContainer';

const EmployeeAddPage = () => {

 
  return (<EmployeeAddContainer/>
  );
};

export default EmployeeAddPage;
